import { DEFAULT_TENURE_TYPE_FITLER_OPTION } from './mapRefinementsFilters';
import type { SelectedFiltersOptionsType } from '../../../../shared/model/constants/filterTypes';
import type { TenureType } from '../../../../shared/model/tsTypes';

export const getFilterCount = (selectedfilters: SelectedFiltersOptionsType): number => {
  const countPropertyType = (array: string[]): number => (array?.length ? 1 : 0);
  const countObjectHasValue = (obj: { value?: string }): number =>
    (obj?.value?.trim().length !== 0 ? 1 : 0);
  const countKeywords = (str: string): number => (str?.trim().length !== 0 ? 1 : 0);
  const countTenureType = (tenureType: TenureType['key']): number =>
    (tenureType && tenureType !== DEFAULT_TENURE_TYPE_FITLER_OPTION ? 1 : 0);
  const countRange = (range: Array<number>): number =>
    range && (range[0] !== 0 || range[1] !== 0 ? 1 : 0);

  const {
    propertyTypes,
    tenureType,
    priceRange,
    floorAreaRange,
    landAreaRange,
    energyEfficiency,
    numParkingSpaces,
    keywords,
  } = selectedfilters;

  if (
    (propertyTypes === undefined || propertyTypes === null) &&
    (tenureType === undefined || tenureType === null) &&
    (priceRange === undefined || priceRange === null) &&
    (floorAreaRange === undefined || floorAreaRange === null) &&
    (landAreaRange === undefined || landAreaRange === null) &&
    (energyEfficiency === undefined || energyEfficiency === null) &&
    (numParkingSpaces === undefined || numParkingSpaces === null) &&
    (keywords === undefined || keywords === null)
  ) {
    return 0;
  }

  return (
    countPropertyType(propertyTypes) +
    countTenureType(tenureType) +
    countRange(priceRange) +
    countRange(floorAreaRange) +
    countRange(landAreaRange) +
    countObjectHasValue(energyEfficiency) +
    countObjectHasValue(numParkingSpaces) +
    countKeywords(keywords)
  );
};
